import React, { useRef } from "react";
import styles from "./Resizer2.module.css";
import { VerticalDivider } from "../dividers";
import { getFilteredDataAttributes } from "../../utils";

const Resizer2 = ({
	active = true,
	additionalPixels = 0,
	className = "",
	idAddition = "",
	isGlobalWidth = false,
	isOnLeft = false,
	max = 40,
	min = 20,
	style = {},
	value,
	onResize = null,

	...dataAttributes
}) => {
	const resizerRef = useRef(null);
	const startXRef = useRef(0);
	const startValueRef = useRef(0);
	const containerWidthRef = useRef(0);
	const filteredDataAttributes = getFilteredDataAttributes(dataAttributes);
	const clamp = (v) => Math.min(max, Math.max(min, v));
	const normalizeValue = (v) => {
		if (typeof v !== "number" || Number.isNaN(v)) {
			return min;
		}
		return clamp(v);
	};

	const safeValue = normalizeValue(value);

	const onMouseMove = (e) => {
		const dx = e.clientX - startXRef.current;
		const delta = (dx * 100) / (isGlobalWidth ? window.innerWidth : containerWidthRef.current);
		const nextValue = isOnLeft ? startValueRef.current - delta : startValueRef.current + delta;
		onResize?.(clamp(nextValue));
	};

	const onMouseUp = () => {
		document.body.style.removeProperty("cursor");
		document.body.style.removeProperty("user-select");
		document.body.style.removeProperty("pointer-events");
		document.removeEventListener("mousemove", onMouseMove);
		document.removeEventListener("mouseup", onMouseUp);
	};

	const onMouseDown = (e) => {
		startXRef.current = e.clientX;
		startValueRef.current = safeValue;
		containerWidthRef.current = resizerRef.current.parentElement.getBoundingClientRect().width;
		document.body.style.cursor = "col-resize";
		document.body.style.userSelect = "none";
		document.body.style.pointerEvents = "none";
		document.addEventListener("mousemove", onMouseMove);
		document.addEventListener("mouseup", onMouseUp);
	};

	const onKeyDown = (e) => {
		if (e.key === "ArrowLeft") {
			onResize?.(clamp(safeValue - 1));
		}
		if (e.key === "ArrowRight") {
			onResize?.(clamp(safeValue + 1));
		}
	};

	if (!active) {
		return <VerticalDivider />;
	}
	return (
		<button
			ref={resizerRef}
			aria-label="Resize panels"
			className={`${styles.resizer__horizontal} ${className}`}
			id={`resizable${idAddition}`}
			style={{
				...style,
				marginLeft: isOnLeft ? additionalPixels : undefined,
				marginRight: !isOnLeft ? additionalPixels : undefined,
			}}
			type="button"
			onKeyDown={onKeyDown}
			onMouseDown={onMouseDown}
			{...filteredDataAttributes}
		/>
	);
};

export default Resizer2;
